/* ============================================================================
 * Movatic WMS — Frontend | CesarFilho 932048016
 * Arquivo: src/components/ui/button.tsx
 * Stub simples de <Button/> compatível com as importações do shadcn/ui.
 * ========================================================================== */
import * as React from "react";

export type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
    variant?: "default" | "outline" | "ghost" | "danger";
    size?: "sm" | "md" | "lg";
};

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
    ({ className = "", variant = "default", size = "md", ...props }, ref) => {
        const v =
            variant === "outline"
                ? "border border-slate-600 bg-transparent text-white hover:bg-slate-800/40"
                : variant === "ghost"
                    ? "bg-transparent hover:bg-slate-800/40 text-white"
                    : variant === "danger"
                        ? "bg-red-600 hover:bg-red-500 text-white"
                        : "bg-blue-600 hover:bg-blue-500 text-white";
        const s = size === "sm" ? "px-2 py-1 text-sm" : size === "lg" ? "px-4 py-2 text-base" : "px-3 py-2 text-sm";
        return (
            <button
                ref={ref}
                className={`rounded-md transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${v} ${s} ${className}`}
                {...props}
            />
        );
    }
);
Button.displayName = "Button";
export default Button;
